import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('LootBoxCard').create(({ theme }) => ({
  root: {
    minHeight: '52px',
    display: 'flex',
    justifyContent: 'space-between',
    paddingLeft: '24px',
    paddingRight: '24px',
    alignItems: 'center',

    '&[data-isenoughkeys="false"]': {
      backgroundColor: 'rgb(39, 41, 47)',
      color: theme.colors.text.secondary,
    },
  },

  divWrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },

  span: {
    fontFamily: 'Inter',
    fontWeight: 460,
    fontSize: theme.sizes.texts.fontSize.m,
    lineHeight: theme.sizes.texts.lineHeight.xl,

    color: theme.colors.text.primary,
  },
}))
